/**
 * Снимок DOM-элемента в PNG (base64 без префикса data:).
 */
export async function captureElementAsPng(element, { scale = 2, backgroundColor = '#ffffff' } = {}) {
  if (!element) return null;
  const html2canvas = (await import('html2canvas')).default;
  const canvas = await html2canvas(element, {
    scale,
    backgroundColor,
    logging: false,
    useCORS: true,
    allowTaint: true,
    onclone: (_doc, clonedElement) => {
      const rows = clonedElement.querySelector?.('.admin-sessions-chart__rows');
      if (rows?.style) {
        rows.style.maxHeight = 'none';
        rows.style.overflow = 'visible';
      }
      clonedElement.style.overflow = 'visible';
    },
  });
  const dataUrl = canvas.toDataURL('image/png');
  const base64 = dataUrl.split(',')[1];
  return {
    base64,
    width: canvas.width,
    height: canvas.height,
  };
}

export async function captureChartBlocks(blocks) {
  const images = [];
  for (const block of blocks) {
    if (!block?.element) continue;
    try {
      const shot = await captureElementAsPng(block.element);
      if (shot?.base64) {
        images.push({
          title: block.title,
          ...shot,
        });
      }
    } catch (e) {
      console.warn('captureChartBlocks:', block.title, e);
    }
  }
  return images;
}
